import { Pog } from "@CommonTypes/merchflow/pog/pog";
import { Color, Flex, ProgressBar, Text } from "src/elements";
import { useTranslation } from "src/i18n";

type Props = {
  title?: string;
  metrics?: Pog["metrics"];
};

export const Metrics = ({ title, metrics }: Props) => {
  const { t } = useTranslation("common");
  const aesthetics = metrics?.aesthetics;

  return (
    <Flex padding="5px" width="210px" direction="column" justify="between" gap="10px">
      {title && (
        <Text variant="h5" color={Color.primary}>
          {title}
        </Text>
      )}

      <Flex direction="column" gap="3px">
        <Text variant="caption1">Return on Space:</Text>
        <ProgressBar percent={metrics?.returnOnSpace} height="28px" isInline />
      </Flex>

      <Flex direction="column" gap="3px">
        <Text variant="caption1">Core Range:</Text>
        <ProgressBar percent={metrics?.coreRange} height="28px" isInline />
      </Flex>

      <Flex direction="column" gap="3px">
        <Text variant="caption1">Shelf Alignment:</Text>
        <ProgressBar percent={metrics?.shelfAlignment} height="28px" isInline />
      </Flex>

      <Flex direction="column" gap="3px">
        <Text variant="caption1">DOS / MOS:</Text>
        <ProgressBar percent={metrics?.dosMos} height="28px" isInline />
      </Flex>

      {/* The score the stores page and its "Ready for store" verdict read: out of 100, so
          no "%". A plan made before it was stored says so, rather than an empty bar that
          reads as a zero. */}
      <Flex direction="column" gap="3px">
        <Text variant="caption1">{t("planogramMetrics.aesthetics.title")}:</Text>
        {aesthetics == null ? (
          <Flex height="28px" align="center">
            <Text variant="caption1" color={Color.textSecondary}>
              {t("metricFilter.notScored")}
            </Text>
          </Flex>
        ) : (
          <ProgressBar percent={aesthetics} suffix="" height="28px" isInline />
        )}
      </Flex>
    </Flex>
  );
};
